import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20scene%20with%20soft%20ambient%20lighting%2C%20comfortable%20modern%20interior%20with%20bookshelf%2C%20warm%20coral%20and%20golden%20sunset%20tones%2C%20digital%20tablet%20displaying%20colorful%20webtoon%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20soft%20bokeh%2C%20cozy%20vibes%2C%20cinematic%20composition%2C%20warm%20light%20from%20window%2C%20peaceful%20mood&width=1920&height=700&seq=cta-comic-reading-scene&orientation=landscape"
          alt="韩漫画网 - 开启免费漫画阅读之旅"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 tracking-wide">
          即刻开启免费漫画之旅
        </h2>
        <p className="text-sm md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          海量正版韩漫资源，每日更新不间断
          <br className="hidden md:block" />
          安全可靠的阅读体验，随时随地畅享漫画世界
        </p>
        <Link
          to="/category/romance"
          className="inline-flex items-center px-8 py-3.5 text-base font-medium rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 mr-2.5">
            <i className="ri-book-open-line text-sm text-background-50"></i>
          </span>
          免费阅读
          <span className="w-5 h-5 flex items-center justify-center ml-2">
            <i className="ri-arrow-right-up-line text-sm"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}